// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pairImage_vOfjA {
  margin: 0 auto;
}

.buttonContainer_qSaG3 {
  width: 100%;
  background-color: white;
  border-radius: 6px;
  box-shadow: rgba(41, 50, 61, 0.16) 0px 1px 3px;
  padding: 0 10px;
}

.buttonContainer_qSaG3 > *:last-child {
  border-bottom: none;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/api-ui-pairing/lib/pairing/actions/steps/Error.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,8CAA8C;EAC9C,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".pairImage {\n  margin: 0 auto;\n}\n\n.buttonContainer {\n  width: 100%;\n  background-color: white;\n  border-radius: 6px;\n  box-shadow: rgba(41, 50, 61, 0.16) 0px 1px 3px;\n  padding: 0 10px;\n}\n\n.buttonContainer > *:last-child {\n  border-bottom: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pairImage": `pairImage_vOfjA`,
	"buttonContainer": `buttonContainer_qSaG3`
};
export default ___CSS_LOADER_EXPORT___;
